import * as React from "react";
const SvgCamera = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 28,
	height: 20,
	viewBox: "0 0 28 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M18.7208 2.37773H3.67923C2.66324 2.37773 1.83961 3.35275 1.83961 4.55551V15.4444C1.83961 16.6471 2.66324 17.6222 3.67923 17.6222H18.7208C19.7368 17.6222 20.5604 16.6471 20.5604 15.4444V4.55551C20.5604 3.35275 19.7368 2.37773 18.7208 2.37773ZM3.67923 0.199951C1.64725 0.199951 0 2.15 0 4.55551V15.4444C0 17.8499 1.64725 19.8 3.67923 19.8H18.7208C20.7528 19.8 22.4 17.8499 22.4 15.4444V4.55551C22.4 2.15 20.7528 0.199951 18.7208 0.199951H3.67923Z",
	fill: "#26CD58"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M26.1999 5.39635C26.1999 5.13947 25.9606 4.97436 25.7609 5.09341L21.5609 7.59679C21.462 7.65577 21.3999 7.77248 21.3999 7.89973V12.2196C21.3999 12.3493 21.4643 12.4678 21.5662 12.5257L25.7662 14.9098C25.9656 15.023 26.1999 14.8577 26.1999 14.6038V5.39635ZM24.9267 3.27579C26.3249 2.4424 27.9999 3.59821 27.9999 5.39635V14.6038C27.9999 16.3812 26.3597 17.5384 24.9636 16.7459L20.7636 14.3617C20.0506 13.957 22.4016 13.5 20.9999 12.2196V7.89973C22.4014 5.8 20.0341 6.19199 20.7267 5.77916L24.9267 3.27579Z",
	fill: "#26CD58"
}));
export default SvgCamera;
